/**
 * Bloc Site JS
 */

jQuery(document).ready(function($){

});